module.exports = __webpack_public_path__ + "static/media/ladditionReservation.dac15a6c.png";